<template>

  <div>

    <!-- URL -->
    <v-row>

      <v-col
        cols="12"
        md="4"
      >

        <v-text-field
          v-model="url"
          label="URL"
          prepend-inner-icon="mdi-link"
        />

      </v-col>


      <!-- Usuario -->
      <v-col
        cols="12"
        md="4"
      >

        <v-text-field
          v-model="username"
          label="Usuario"
          prepend-inner-icon="mdi-account"
        />

      </v-col>


      <!-- Contraseña -->
      <v-col
        cols="12"
        md="4"
      >

        <v-text-field
          v-model="password"
          label="Contraseña"
          prepend-inner-icon="mdi-lock"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="
            showPassword
              ? 'mdi-eye-off'
              : 'mdi-eye'
          "
          append-outer-icon="mdi-content-copy"
          @click:append="togglePassword"
          @click:append-outer="copyPassword"
        />

      </v-col>

    </v-row>

  </div>

</template>


<script>

  export default {

    props: {

      value: {
        type: Object,
        default: () => ({})
      },

    },

    data () {

      return {

        showPassword: false,

      }

    },

    computed: {

      username: {

        get () {
          return this.value.username || ''
        },

        set (value) {

          this.$emit('input', {
            ...this.value,
            username: value,
          })

        },

      },

      password: {

        get () {
          return this.value.password || ''
        },

        set (value) {

          this.$emit('input', {
            ...this.value,
            password: value,
          })

        },

      },

      url: {

        get () {
          return this.value.url || ''
        },

        set (value) {

          this.$emit('input', {
            ...this.value,
            url: value,
          })

        },

      },

    },

    methods: {

      togglePassword () {

        this.showPassword =
          !this.showPassword

      },

      async copyPassword () {

        if (!this.password) {
          return
        }

        await navigator.clipboard.writeText(
          this.password,
        )

      },

    },

  }

</script>
